export const FETCH_STARTED = 'scenes/Claims/fetch_started'
export const UPDATE_CLAIMS = 'scenes/Claims/update_claims'
export const FILTER_CHANGED = 'scenes/Claims/filter_changed'
export const STATUS_CLAIM = 'scenes/Claims/status_claim'



// WEBPACK FOOTER //
// ./src/scenes/Claims/constants.js